import React from 'react';

import { FormattedMessage } from 'react-intl';
import { useNavigate, useParams } from 'react-router-dom';

import { DocumentWrapper } from 'components';
import { formatterContextValues } from 'utils/documentFormatting';

import messages from './messages';

const VARIANT_BUSINESS = 'business';
const VARIANT_CUSTOMER = 'customer';
const AVAILABLE_VARIANTS = [VARIANT_BUSINESS, VARIANT_CUSTOMER];

const TermsOfService = ({ variant: variantProp }) => {
  const params = useParams();
  const navigate = useNavigate();
  const variant = variantProp ?? params.variant;
  const translationMessage = AVAILABLE_VARIANTS.includes(variant)
    ? messages[variant]
    : messages.variantNotExits;

  return (
    <>
      {variant === VARIANT_CUSTOMER && (
        <div style={{ padding: '12px 16px' }}>
          <button
            type="button"
            onClick={() => navigate('/my-account')}
            style={{
              background: 'none',
              border: 'none',
              padding: 0,
              cursor: 'pointer',
              font: 'inherit',
              fontSize: 14,
              color: 'inherit',
            }}
          >
            ← Back to account
          </button>
        </div>
      )}
      <DocumentWrapper>
        <FormattedMessage
          {...translationMessage}
          values={{
            ...formatterContextValues,
            list: formatterContextValues.listAlt,
          }}
        />
      </DocumentWrapper>
    </>
  );
};

export default TermsOfService;